module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "registro"
  }, [_vm._h('div', {
    staticClass: "container"
  }, [_vm._m(0), " ", " ", _vm._h('form', [_vm._h('div', {
    staticClass: "row"
  }, [_vm._h('div', {
    staticClass: "col-md-6"
  }, [_vm._h('div', {
    staticClass: "form-group row"
  }, [_vm._h('label', {
    staticClass: "col-sm-2 col-form-label"
  }, ["Nombre:*"]), " ", _vm._h('div', {
    staticClass: "col-sm-10"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registro.nombre),
      expression: "registro.nombre"
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm._s(_vm.registro.nombre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registro.nombre = $event.target.value
      }
    }
  })])]), " ", _vm._h('div', {
    staticClass: "form-group row"
  }, [_vm._h('label', {
    staticClass: "col-sm-2 col-form-label"
  }, ["Telefono:"]), " ", _vm._h('div', {
    staticClass: "col-sm-10"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registro.telefono),
      expression: "registro.telefono"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.registro.telefono)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registro.telefono = $event.target.value
      }
    }
  })])]), " ", _vm._h('div', {
    staticClass: "form-group row"
  }, [_vm._h('label', {
    staticClass: "col-sm-2 col-form-label"
  }, ["Perfil:"]), " ", _vm._h('div', {
    staticClass: "col-sm-10"
  }, [_vm._h('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registro.perfil),
      expression: "registro.perfil"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.registro.perfil = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_vm._h('option', ["Motos"]), " ", _vm._h('option', ["Autos"]), " ", _vm._h('option', ["Camionetas"]), " ", _vm._h('option', ["Camiones"])])])])]), " ", _vm._h('div', {
    staticClass: "col-md-6"
  }, [_vm._h('div', {
    staticClass: "form-group row"
  }, [_vm._h('label', {
    staticClass: "col-sm-2 col-form-label"
  }, ["Apellido:*"]), " ", _vm._h('div', {
    staticClass: "col-sm-10"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registro.apellido),
      expression: "registro.apellido"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.registro.apellido)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registro.apellido = $event.target.value
      }
    }
  })])]), " ", _vm._h('div', {
    staticClass: "form-group row"
  }, [_vm._h('label', {
    staticClass: "col-sm-2 col-form-label"
  }, ["Empresa:"]), " ", _vm._h('div', {
    staticClass: "col-sm-10"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registro.empresa),
      expression: "registro.empresa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.registro.empresa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registro.empresa = $event.target.value
      }
    }
  })])]), " ", _vm._h('div', {
    staticClass: "form-group row"
  }, [_vm._h('label', {
    staticClass: "col-sm-2 col-form-label"
  }, ["E-mail:*"]), " ", _vm._h('div', {
    staticClass: "col-sm-10"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registro.mail),
      expression: "registro.mail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.registro.mail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registro.mail = $event.target.value
      }
    }
  })])]), " ", _vm._h('div', {
    staticClass: "form-group row"
  }, [_vm._h('label', {
    staticClass: "col-sm-2"
  }, ["Ocupación:"]), " ", _vm._h('div', {
    staticClass: "col-sm-10"
  }, [_vm._h('div', {
    staticClass: "form-check"
  }, [_vm._h('label', {
    staticClass: "custom-control custom-checkbox"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registro.comprador),
      expression: "registro.comprador"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.registro.comprador) ? _vm._i(_vm.registro.comprador, null) > -1 : _vm._q(_vm.registro.comprador, true)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.registro.comprador,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.registro.comprador = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.registro.comprador = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.registro.comprador = $$c
        }
      }
    }
  }), " ", _vm._h('span', {
    staticClass: "custom-control-indicator"
  }), " ", _vm._h('span', {
    staticClass: "custom-control-description"
  }, ["Comprador"])])]), " ", _vm._h('div', {
    staticClass: "form-check"
  }, [_vm._h('label', {
    staticClass: "custom-control custom-checkbox"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registro.vendedor),
      expression: "registro.vendedor"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.registro.vendedor) ? _vm._i(_vm.registro.vendedor, null) > -1 : _vm._q(_vm.registro.vendedor, true)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.registro.vendedor,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.registro.vendedor = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.registro.vendedor = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.registro.vendedor = $$c
        }
      }
    }
  }), " ", _vm._h('span', {
    staticClass: "custom-control-indicator"
  }), " ", _vm._h('span', {
    staticClass: "custom-control-description"
  }, ["Vendedor"])])])])])]), " ", _vm._h('div', {
    staticClass: "col-md-6 offset-md-3"
  }, [_vm._h('h6', ["¿CÓMO CONOCISTE WPO?"]), " ", _vm._h('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registro.origen),
      expression: "registro.origen"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.registro.origen = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_vm._h('option', ["RECIBI UN MAIL"]), " ", _vm._h('option', ["POR AMIGOS"]), " ", _vm._h('option', ["OTROS"])])]), " ", _vm._h('div', {
    staticClass: "col-md-6 offset-md-3",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._h('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.enviarRegistro
    }
  }, ["ENVIAR"])]), " ", _vm._m(1)])]), " "])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "row"
  }, [_vm._h('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._h('img', {
    attrs: {
      "src": "/static/registro/ImgRegistro.jpg",
      "alt": ""
    }
  })]), " ", _vm._h('div', {
    staticClass: "col-md-6"
  }, [_vm._h('div', {
    staticClass: "texto"
  }, [_vm._h('p', ["\n                        Bienvenidos a ", _vm._h('b', ["World Part Online"]), ", la plataforma digital exclusiva para la comercialización de\n                        repuestos y accesorios de todos las marcas, de todas las industrias.\n                    "]), " ", _vm._h('p', ["\n                        Esta herramienta digital te permitirá estar conectado con todos los profesionales, compradores y\n                        vendedores del rubro de una forma fácil, dinámica y efectiva.\n                    "]), " ", _vm._h('p', ["\n                        Podrás comprar y vender recibiendo las mejores propuestas en tiempo y precio, además tendrás la\n                        posibilidad de ser valorado por tu servicio y recibir importantes incentivos.\n                    "]), " ", _vm._h('p', [_vm._h('b', ["World Part Online"]), " es la herramienta que faltaba, publicidad, negocio, estadísticas,\n                        asesoramiento, distribución, sistemas. Todo y de una forma muy fácil y pro activa.\n                    "]), " ", _vm._h('p', [_vm._h('b', ["World Part Online"]), ", liderá tu mundo."])])])])
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    }
  }, [_vm._h('p', {
    staticClass: "terminos"
  }, ["Al registrarme declaro que soy mayor de edad y acepto", _vm._h('br'), " ", _vm._h('a', {
    attrs: {
      "href": "#"
    }
  }, ["Los Terminos y condiciones"]), "  y las ", _vm._h('a', {
    attrs: {
      "href": "#"
    }
  }, ["Politicas de privacidad"])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f2056ec0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Registro.vue
// module id = 72
// module chunks = 1